@let branding = brandingService.branding$ | async;

@if (branding !== undefined && branding !== null) {
    <div class="mm-slack-page">
        <div class="mm-slack-content">
            <app-logos [logo]="branding.learn.logos.default" class="mm-slack-logo"></app-logos>

            <h1 class="mm-title">{{ 'slack.success.title' | translate }}</h1>

            <p class="mm-description">{{ 'slack.success.description' | translate }}</p>

            <app-button type="primary" [action]="openSlackApp">
                {{ 'slack.success.button' | translate }}
            </app-button>
        </div>
    </div>
}
